<script>
  import {mapState} from 'vuex'
  import GenericLoader from './generic-loader.vue'

  export default {
    name: "bootcamp-meeting-loader",
    extends: GenericLoader,
    computed: {
      ...mapState('workout', {
        events: 'active',
        loading: 'loading'
      }),
    },
    methods: {
      load() {
        return this.$store.dispatch('workout/load')
      }
    }

  }
</script>

<style scoped>

</style>
